var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('sqr-hero',{attrs:{"short":"documents","title-raw":_vm.$route.query.title,"subtitle-raw":_vm.$route.query.subtitle,"is-primary":"","is-bold":"","is-loading":_vm.loading,"is-fluid":""}}),_c('sqr-error',{attrs:{"error":_vm.loadError}}),_c('documents',{attrs:{"bid":_vm.bid,"folder":_vm.folder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }